import CONTRATO_DIRECTORIO from '@/graphql/querys/administracion/contratos/contrato/directorio/contratoDirectorio.gql';
import AGREGAR_CONTRATO_DIRECTORIO from '@/graphql/mutations/administracion/contratos/contrato/directorio/agregarContratoDirectorio.gql';
import ACTUALIZAR_CONTRATO_DIRECTORIO from '@/graphql/mutations/administracion/contratos/contrato/directorio/actualizarContratoDirectorio.gql';

export default {
  methods: {
    async mixRegistrarDirectorio() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_DIRECTORIO,
          variables: {
            directorio: this.directorio,
          },
          update: (store, { data: { agregarContratoDirectorio } }) => {
            const query = {
              query: CONTRATO_DIRECTORIO,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoDirectorio } = store.readQuery(query);
            const contratoDirectorioCopia = contratoDirectorio.slice();
            contratoDirectorioCopia.push(agregarContratoDirectorio);
            store.writeQuery({
              ...query,
              data: {
                contratoDirectorio: contratoDirectorioCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixActualizarDirectorio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_DIRECTORIO,
          variables: {
            id: this.directorioEditar.id,
            directorio: this.directorio,
          },
          update: (store, { data: { actualizarContratoDirectorio } }) => {
            const query = {
              query: CONTRATO_DIRECTORIO,
              variables: {
                idContrato: this.directorioEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoDirectorio } = data;
            const index = contratoDirectorio
              .findIndex((contratDirectorio) => contratDirectorio.id
              === actualizarContratoDirectorio.id);
            if (index !== -1) {
              contratoDirectorio.splice(index, 1, actualizarContratoDirectorio);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
